import React from 'react';
import {useParams} from 'react-router';
import {useSession} from '../../../../../firebase/UserProvider';
import {useReportStore} from '../../../useReportStore';

const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'wss://awp.minsky.ai/ws/collab';

export default function useReportEditorCore() {
    const {reportId} = useParams();
    const {user} = useSession();

    const setEditorView = useReportStore(s => s.setEditorView);
    const setReportId = useReportStore(s => s.setReportId);
    const setIsSelectedText = useReportStore(s => s.setIsSelectedText);
    const editorView = useReportStore(s => s.editorView);

    React.useEffect(() => {
        if (reportId) {
            setReportId(reportId);
        }
        return () => {
            setReportId(null);
        };
    }, [reportId, setReportId]);

    React.useEffect(() => {
        return () => {
            setEditorView(null);
        };
    }, [setEditorView]);

    const handleEditorReady = React.useCallback((view) => {
        setEditorView(view);
    }, [setEditorView]);

    const handleSelectionChange = React.useCallback((hasSelection) => {
        setIsSelectedText(hasSelection);
    }, [setIsSelectedText]);

    const websocketUrl = WEBSOCKET_URL;
    // const websocketUrl = 'ws://localhost:8080'

    return {
        reportId,
        user,
        editorView,
        websocketUrl,
        handleEditorReady,
        handleSelectionChange,
    };
}

